import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import Section from 'pages/components/Section';
import { formatPercent, formatPrice, getDateFormat } from 'pages/Utils/Formats';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import { PaymentPlanConfig } from 'Domain/PaymentPlan/Helper/PaymentsCalculator';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    padding: 0,
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    padding: '5px 0',
    fontSize: 14,
  },
}));

type DisplayPayOusProps = {
  paymentPlanConfig: PaymentPlanConfig;
};

export default function DisplayPayOuts({
  paymentPlanConfig,
}: DisplayPayOusProps) {
  const { t } = useTranslation();
  const payouts = paymentPlanConfig.getPayOutsCollections();
  return (
    <Section title={t('payments_out')} accordion={true} initOpen={true}>
      <TableContainer sx={{ marginTop: -2 }}>
        <Table
          sx={{
            tableLayout: 'fixed',
            '& tbody tr:last-child td': {
              borderBottom: 'none',
            },
          }}
          aria-label="simple table"
        >
          <TableHead>
            <Row
              title={'#'}
              values={payouts.map((collection: any, i: number) => i + 1)}
            />
          </TableHead>
          <TableBody>
            <Row
              title={t('FORM.FIELD.date')}
              values={payouts.map((collection: any, i: number) =>
                'name' in collection.date
                  ? t(collection.date.name, collection.date.params)
                  : collection.date.format(getDateFormat()),
              )}
            />
            <Row
              title={t('FORM.FIELD.amount')}
              values={payouts.map((collection: any, i: number) =>
                formatPrice(collection.amount),
              )}
            />
          </TableBody>
        </Table>
      </TableContainer>

      {FeesInfos(paymentPlanConfig)}
    </Section>
  );
}

function Row({ title, values }: any) {
  return (
    <>
      <TableRow style={{ fontWeight: 'bold' }}>
        <StyledTableCell width={30} align="left" sx={{ fontWeight: 'bold' }}>
          {title}
        </StyledTableCell>
        {values.map((value: any, i: number) => (
          <StyledTableCell key={i} align="right">
            {value}
          </StyledTableCell>
        ))}
      </TableRow>
    </>
  );
}

function FeesInfos(paymentPlanConfig: PaymentPlanConfig) {
  const { t } = useTranslation();

  const infos = {
    fees: [
      formatPercent(paymentPlanConfig.getFees()),
      formatPrice(paymentPlanConfig.getFeesValue()),
    ],
    vat: [
      formatPercent(paymentPlanConfig.getVAT()),
      formatPrice(paymentPlanConfig.getVATValue()),
    ],

    totalttc: [
      '',
      formatPrice(
        paymentPlanConfig.getFeesValue() + paymentPlanConfig.getVATValue(),
      ),
    ],
  } as Record<string, Array<string>>;

  return (
    <TableContainer
      sx={{ border: '1px solid lightgray', width: '300px', padding: 1 }}
    >
      <Table
        sx={{
          tableLayout: 'fixed',
          '& tbody tr:last-child td': {
            borderBottom: 'none',
          },
        }}
        aria-label="simple table"
      >
        <TableBody>
          {Object.keys(infos).map((key: string, i: number) => (
            <Row key={i} title={t(`FORM.FIELD.${key}`)} values={infos[key]} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
